export const routeEditLogic = {
  props: {
    config: {
      type: Object,
      default: () => ({
        id: 'open-id'
      })
    }
  },
  data () {
    return {
      mixValue: null,
      mixState: null
    }
  },
  computed: {
    modalEditorID () {
      return this.config.id
    },
    mixWatchedField () {
      return `${this.mixState}-${this.mixValue}`
    }
  },
  watch: {
    mixWatchedField: {
      immediate: true,
      handler () {
        this.$nextTick(() => {
          if (this.mixState === 'new') {
            return this.mixHookNew({ state: this.mixState })
          }
          if (this.mixState) {
            return this.mixHookState({ state: this.mixState, value: this.mixValue })
          }
          if (!this.mixState) {
            return this.mixHookReset()
          }
        })
      }
    },
    $route: {
      immediate: true,
      handler () {
        this.$nextTick(() => {
          // Query string is clean
          if (!this.modalEditorID || !this.$route.query || !this.$route.query[this.modalEditorID]) {
            return this._handleHook()
          }

          let value = this.$route.query[this.modalEditorID]
          // Modal new
          if (value === 'new') {
            return this._handleHook({ state: 'new' })
          }

          const routeStateValue = this.mixGetRouteStateValue(this.modalEditorID)

          if (routeStateValue) {
            const { state, value } = routeStateValue
            return this._handleHook({ state, value })
          }

          // ERROR
          console.error(new Error('MODALS => ERROR HANDLER ROUTER'))
        })
      }
    }
  },
  methods: {
    // User Interface
    mixGetRouteStateValue (param) {
      let value = this.$route.query[param] || ''
      let start = value.indexOf('[')
      let end = value.indexOf(']')
      // Modal edit
      if (start !== -1 && end !== -1) {
        let state = value.slice(0, start)
        value = value.slice(start + 1, end)
        return { state, value }
      }
      return null
    },
    mixSetRoute ({ value, state = 'edit', id = this.modalEditorID } = {}) {
      let query = { ...this.$route.query }
      if (value) {
        query = { ...query, [id]: `${state}[${value}]` }
      } else if (state === 'new') {
        query = { ...query, [id]: 'new' }
      } else {
        delete query[id]
      }
      this.$router.replace({ ...this.$router.currentRoute, query })
    },
    // END User Interface

    // REQUIRED INTERFACE
    /**
     * @desc Interface for edit. Trigger => Each edit
     * @param value
     * @param state
     */
    mixHookState ({ value, state }) {
      console.error(new Error('MISSING HANDLER FOR INTERFACE "EDIT" =>'), value)
    },
    /**
     * @desc Interface for new. Trigger => Each new
     * @param state
     */
    mixHookNew ({ state }) {
      console.error(new Error('MISSING HANDLER FOR INTERFACE "NEW"'))
    },
    /**
     * @desc Interface for reset data of modal
     */
    mixHookReset () {
      console.error(new Error('MISSING HANDLER FOR INTERFACE "Reset"'))
    },
    // END REQUIRED INTERFACE
    /**
     * @desc Handler for hooks a new and change state
     * @param payload
     * @private
     */
    _handleHook ({ state = null, value = null } = {}) {
      this.mixState = state
      this.mixValue = value
    }
  }
}
